/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument } from './HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument';
import {
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSONTyped,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON,
} from './HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface HchbPatientDetailsDocumentsGeneratedDocumentsInner
 */
export interface HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    previous_generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    type?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    instance_id?: string;
    /**
     * 
     * @type {HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    external_ehr_document?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument;
}


/**
 * @export
 */
export const HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package'
} as const;
export type HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = typeof HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum[keyof typeof HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum];


/**
 * Check if a given object implements the HchbPatientDetailsDocumentsGeneratedDocumentsInner interface.
 */
export function instanceOfHchbPatientDetailsDocumentsGeneratedDocumentsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSON(json: any): HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    return HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'generated_at': !exists(json, 'generated_at') ? undefined : json['generated_at'],
        'previous_generated_at': !exists(json, 'previous_generated_at') ? undefined : json['previous_generated_at'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'instance_id': !exists(json, 'instance_id') ? undefined : json['instance_id'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSON(value?: HchbPatientDetailsDocumentsGeneratedDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'generated_at': value.generated_at,
        'previous_generated_at': value.previous_generated_at,
        'type': value.type,
        'instance_id': value.instance_id,
        'external_ehr_document': HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON(value.external_ehr_document),
    };
}

